import React, { useCallback, useEffect, useState } from "react";
import { withTranslation, useTranslation } from "react-i18next";
import { usePreCheckInContext } from "../modules/precheckin/contexts/PreCheckInContext";
import { get, isEmpty } from "lodash";
import FloatInput from "../modules/precheckin/FloatInput";

const AddressPicker = (props) => {
  const initialFormState = {
    addressOne: "",
    addressTwo: "",
    city: "",
    state: "",
    postalCode: "",
  }; 

  const {
    propertyUid,
    func: { useFormInput, updateGuests },
    data: { presets, guests, guestService, configuration },
    components: { PreCheckInHeader },
  } = usePreCheckInContext();

  const { t } = useTranslation();
  const [formData, handleFormChange, setFormValues] =
    useFormInput(initialFormState);
  const [validateForm, setValidateForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [isPageMounted, setIsPageMounted] = useState(true);
  const [guestNumber, setGuestNumber] = useState(1);
  const [currentGuest, setCurrentGuest] = useState({});
  const [fields, setFields] = useState([]);

  const interfaceTypeIsHotelKey =
    get(configuration, "pmsInterfaceType") === "hotelkey";

  const allFields = useCallback(() => {
    let tmp = [];
    if (!interfaceTypeIsHotelKey)
      tmp = tmp.concat(
        { name: "addressOne", text: `${t("ADDRESS")} 1` },
        { name: "addressTwo", text: `${t("ADDRESS")} 2` }
      );
    else tmp = tmp.concat({ name: "addressOne", text: t("ADDRESS") });
    tmp = tmp.concat([
      { name: "city", text: t("CITY") },
      { name: "state", text: t("STATE_PROVINCE") },
      { name: "postalCode", text: t("POSTAL_CODE") },
    ]);
    setFields(tmp);
  }, [interfaceTypeIsHotelKey, t]);

  useEffect(() => {
    const { guestNumber: matchedGuestNumber } = props.match.params;
    setGuestNumber(matchedGuestNumber);
    if (guestService && guests && isPageMounted) {
      setIsPageMounted(false);
      const currGuest = guests.allGuests()[matchedGuestNumber - 1];
      setCurrentGuest(currGuest);

      const addressData = {
        addressOne: get(currGuest, "address.address_one"),
        addressTwo: get(currGuest, "address.address_two"),
        city: get(currGuest, "address.city_address"),
        state: get(currGuest, "address.state_address"),
        postalCode: get(currGuest, "address.postcode"),
      };
      setFormValues({ ...formData, ...addressData });

      allFields();
    }
  }, [
    props.match.params,
    propertyUid,
    isPageMounted,
    guests,
    formData,
    setFormValues,
    guestService,
    allFields,
  ]);

  const addBtn = () => {
    setSubmitted(true);
    const validate = guestService.requiredAddressCollection
      ? !isEmpty(formData.addressOne) &&
        (interfaceTypeIsHotelKey || !isEmpty(formData.addressTwo)) &&
        !isEmpty(formData.city) &&
        !isEmpty(formData.state) &&
        !isEmpty(formData.postalCode)
      : true;
    if (validate) {
      let addressData = {
        address_one: formData.addressOne,
        address_two: formData.addressTwo,
        city_address: formData.city,
        state_address: formData.state,
        postcode: formData.postalCode,
      };
      keepGuestDataAndMove(addressData);
    }
    setValidateForm(validate);
  };

  const keepGuestDataAndMove = (addressData) => {
    const guestData = {
      ...currentGuest,
      address: {
        ...currentGuest.address,
        ...addressData,
      },
    };
    setCurrentGuest(guestData);
    guests.UpdateByNumber(guestNumber - 1, guestData);
    updateGuests(guests);
    props.onSave(currentGuest.address)
  };

  
  return (
    <div className="h-full">
      <PreCheckInHeader onBack={props.onBack}
          title={t("ADDRESS")}
          headerLink
        />
        {presets && (
          <>
            <section
              id="content"
              className="relative flex flex-col px-9 w-full flex-1 md:flex-0 pt-6">
              <div className="flex flex-col h-full">
                <div className="flex mb-10 w-full">
                  <div className="font-normal m-auto w-full">
                    <p
                      className="mb-12 type-normal large"
                      style={{ color: presets.titleColor }}>
                      {t("ADDRESS_COLLECTION_DESCRIPTION")}
                    </p>
                    {fields.map((item, index) => (
                      <div
                        className="flex flex-col"
                        key={index}>
                        <div className="pt-5 mb-24 relative">
                          <FloatInput
                            id={item.name}
                            name={item.name}
                            label={t(item.text)}
                            span={
                              guestService.requiredAddressCollection
                                ? `*${t("REQUIRED")}`
                                : ""
                            }
                            classNameLabel="mb-6 type-title small"
                            classNameSpan="text-gray-400 type-regular small pl-2"
                            classNameInput="capitalize border-b w-full px-4 rounded-none outline-none focus:outline-none type-normal large md:mb-10"
                            onChange={handleFormChange}
                            value={get(formData, item.name, "")}
                            labelColor={presets.backgroundColorTopBar}
                            borderColor={presets.backgroundColorTopBar}
                          />
                          {!validateForm &&
                            submitted &&
                            isEmpty(get(formData, item.name)) && (
                              <p className="text-14 text-center text-red-500 mt-5">
                                {t(
                                  "PLEASE_FILL_OUT_REQUIRED",
                                  "Please fill all the required fields"
                                )}
                              </p>
                            )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <button
                  className={`app-button-ipad type-title medium ${presets.buttonStyleName}`}
                  style={{
                    backgroundColor: presets.backgroundColorTopBar,
                    color: presets.appHomeTextCallToAction,
                  }}
                  onClick={() => addBtn()}>
                  {t("SAVE")}
                </button>
              </div>
            </section>
            <button
              className="app-button-mobile type-title medium "
              style={{
                backgroundColor: presets.backgroundColorTopBar,
                color: presets.appHomeTextCallToAction,
                position: "fixed",
                bottom: 0,
                left: 0,
              }}
              onClick={() => addBtn()}>
              {t("SAVE")}
            </button>
          </>
        )}
    </div>
  );
};

export default withTranslation()(AddressPicker);
